import React from 'react';
import { shuffleArray } from '../utils/shuffle';
import { MOSAIC_TILE_COUNT } from '../constants/game';

interface UseMosaicPiecesParams {
  isMosaic: boolean;
  currentRound: number;
  tileCount?: number;
}

export function useMosaicPieces({ isMosaic, currentRound, tileCount }: UseMosaicPiecesParams) {
  const count = tileCount ?? MOSAIC_TILE_COUNT;

  return React.useMemo(() => {
    const indices = Array.from({ length: count * count }, (_, index) => index);
    if (!isMosaic) {
      return indices;
    }
    return shuffleArray(indices);
  }, [isMosaic, currentRound, count]);
}

